const state = {
  sidebarControl: {
    width: '8',
    opacity: '0'
  }
}

const getters = {
  sidebarControl: (state) => state.sidebarControl
}

const actions = {
  toShowSidebar: ({ commit }) => {
    commit('setSidebarControl', {
      width: '80',
      opacity: '95'
    })
  },
  toHideSidebar: ({ commit }) => {
    commit('setSidebarControl', {
      width: '8',
      opacity: '0'
    })
  }
}

const mutations = {
  setSidebarControl: (state, sidebarControl) => {
    state.sidebarControl = { ...state.sidebarControl, ...sidebarControl }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
